<template>

    <div :class="`VueTables VueTables--${props.source}`" slot-scope="props">

        <div :class="props.theme.row">
            <div :class="props.theme.column">
                <div class="row justify-content-between align-items-center">
                    <div class="col-lg-3">
                        <div v-if="!props.opts.filterByColumn && props.opts.filterable"
                            :class="`${props.theme.field} ${props.theme.inline} ${props.theme.left} VueTables__search w-100`">
                            <vnodes :vnodes="props.slots.beforeFilter"/>
                            <vt-generic-filter/>
                            <vnodes :vnodes="props.slots.afterFilter"/>
                        </div>
                        <vnodes :vnodes="props.slots.afterFilterWrapper"/>
                    </div>
                    <div class="col-lg-4">
                        <div class="row justify-content-end">
                            <div class="col-lg-6">
                                <div v-if="props.perPageValues.length > 1"
                                    :class="`${props.theme.field} ${props.theme.inline} justify-content-end text-center VueTables__limit`">
                                    <vnodes :vnodes="props.slots.beforeLimit"/>
                                    <vt-per-page-selector/>
                                    <vnodes :vnodes="props.slots.afterLimit"/>

                                </div>
                            </div>
                            <div v-if="props.opts.columnsDropdown" class="col-xl-6">
                                <div v-if="props.opts.columnsDropdown"
                                    :class="`VueTables__columns-dropdown-wrapper w-100 ${props.theme.right} ${props.theme.dropdown.container}`">
                                    <vt-columns-dropdown/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="VueTables__pagination-wrapper" v-if="props.opts.pagination.dropdown && props.totalPages > 1">
                    <div :class="`${props.theme.field} ${props.theme.inline} ${props.theme.right} VueTables__dropdown-pagination`">
                        <vt-dropdown-pagination/>
                    </div>
                </div>

               
            </div>
        </div>

        <vnodes :vnodes="props.slots.beforeTable"/>
        <div class="table-responsive">
            <vt-table ref="vt_table"/>
        </div>
        <vnodes :vnodes="props.slots.afterTable"/>

        <vt-pagination/>

    </div>
</template>

<script>
    import VtColumnsDropdown from 'vue-tables-2/compiled/components/VtColumnsDropdown'
    import VtDropdownPagination from 'vue-tables-2/compiled/components/VtDropdownPagination'
    import VtGenericFilter from 'vue-tables-2/compiled/components/VtGenericFilter'
    import VtPerPageSelector from 'vue-tables-2/compiled/components/VtPerPageSelector';
    import VtTable from 'vue-tables-2/compiled/components/VtTable';
    import VtPagination from 'vue-tables-2/compiled/components/VtPagination'

    export default {
        name: "VtDataTable",
        props: ['props'],
        components: {
            VtGenericFilter,
            VtPerPageSelector,
            VtColumnsDropdown,
            VtDropdownPagination,
            VtTable,
            VtPagination,
            vnodes: {
                functional: true,
                render: (h, ctx) => ctx.props.vnodes
            }
        }
    }
</script>